import React from "react";
// Same page-local theme tokens as My Files: this surface also renders outside
// the .excalidraw container, where the editor's CSS variables don't exist.
import "./my-files/my-files.scss";

/**
 * Friendly, uniform "not found" surface for a cloud file the viewer can't open
 * (nonexistent, private + not owner, logged-out, or soft-deleted). Deliberately
 * leaks no existence information — the copy and markup are identical whether the
 * file is private, deleted, or never existed. Shared by `/f/<id>`, `/share/<id>`
 * and unknown app routes.
 */
export const CloudFile404: React.FC = () => {
  return (
    <div
      data-testid="cloud-file-404"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        height: "100%",
        gap: "0.75rem",
        padding: "2rem",
        background: "var(--mf-bg)",
        color: "var(--mf-text)",
      }}
    >
      <h1 style={{ fontSize: "1.5rem", margin: 0 }}>
        This mindmap doesn&apos;t exist or isn&apos;t shared
      </h1>
      <p style={{ color: "var(--mf-text-muted)", maxWidth: "28rem" }}>
        The link may be broken, or the file may be private or deleted.
      </p>
      <p
        style={{
          color: "var(--mf-text-muted)",
          maxWidth: "28rem",
          fontSize: "0.85rem",
        }}
      >
        Shared mindmaps look like{" "}
        <code
          style={{
            background: "var(--mf-hover-bg)",
            padding: "0.1rem 0.35rem",
            borderRadius: "0.3rem",
          }}
        >
          /share/…
        </code>
      </p>
      <a
        href="/"
        // New tab: inside a Notion iframe embed a same-frame navigation would
        // replace the embed content with the full app.
        target="_blank"
        rel="noopener noreferrer"
        style={{
          marginTop: "0.5rem",
          color: "var(--mf-accent)",
          fontWeight: 600,
          textDecoration: "none",
        }}
      >
        Go to Mindmap.so
      </a>
    </div>
  );
};

export default CloudFile404;
